import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { CreateCrtPeriodDetailsDialog } from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import { costOfGoodsSearchSchema, useCreateCostOfGoods } from '@/hooks/queries/crt/useCostOfGoods'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CostOfGoodsDataTable from './-components/CostOfGoodsDataTable'

export const Route = createFileRoute('/_auth/_modules/crt/cost-of-goods/')({
  component: RouteComponent,
  validateSearch: (search) => costOfGoodsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateCostOfGoods({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('costOfGoods.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_cost_of_goods_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('costOfGoods.createButton')}
            title={t('createCostOfGoodsDialog.title')}
            nameLabel={t('createCostOfGoodsDialog.name.label')}
            namePlaceholder={t('createCostOfGoodsDialog.name.placeholder')}
            isPending={isPending}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('costOfGoods.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <CostOfGoodsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
